import type { TMigrateFromCsvEntry } from 'types';

const LINE_USER_ID_COLUMN = 'line_user_id';
const BASIC_ID_COLUMN = 'basic_id';

function parseColumns(line: string) {
  return line.split(',').map((column) => column.trim());
}

function resolveColumnIndexes(columns: string[]) {
  const normalizedColumns = columns.map((column) => column.toLowerCase());
  const lineUserIdIndex = normalizedColumns.indexOf(LINE_USER_ID_COLUMN);
  const basicIdIndex = normalizedColumns.indexOf(BASIC_ID_COLUMN);

  if (lineUserIdIndex !== -1 && basicIdIndex !== -1) {
    return {
      hasHeader: true,
      lineUserIdIndex,
      basicIdIndex,
    };
  }

  return {
    hasHeader: false,
    lineUserIdIndex: columns.length >= 3 ? 1 : 0,
    basicIdIndex: columns.length >= 3 ? 2 : 1,
  };
}

export function parseMigrationCsv(text: string): TMigrateFromCsvEntry[] {
  const lines = text.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length === 0) return [];

  const firstLineColumns = parseColumns(lines[0]);
  const {
    hasHeader,
    lineUserIdIndex,
    basicIdIndex,
  } = resolveColumnIndexes(firstLineColumns);
  const dataLines = hasHeader ? lines.slice(1) : lines;

  return dataLines.map((line) => {
    const columns = parseColumns(line);

    return {
      line_user_id: columns[lineUserIdIndex] ?? '',
      basic_id: columns[basicIdIndex] ?? '',
    };
  });
}
